export default __webpack_public_path__ + "static/media/pbitips-background.7bf25830.webp";